export enum ModuleUniqueIds {
    Environmental = 'ENV',
    Events = 'AI',
    PeriodStatistics = 'PS',
    Register = 'REG',
    Risk = 'RSK',
    Admin = 'AD',
    ActionTracking = 'AC',
    PermitToWork = 'PTW',
    TallyIndex = 'TI',
    People = 'PPL'
}
